import React from 'react';
import {Box, Grid2, Stack, Tab} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {useLoading} from "../../loading-context/useLoading";
import {Camera} from "./Camera";
import {useTranslation} from "react-i18next";

export const Cameras = ({details}) => {
    const [value, setValue] = React.useState(`${details.cameras[0].id}`);
    const { t } = useTranslation();

    useLoading(!details || !details.cameras);

    if(!details.cameras) return "";

    const handleTabChange = (event, newValue) => {
        if(value === newValue) return;
        setValue(`${newValue}`);
    };

    const getTabName = (camera) => {
        return "Kamera " + t(`cameraType:${camera.type}`);
    }

    return <Box sx={{ paddingRight: 2, height: "100%" }} width="100vw">
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabContext value={value} >
                <Stack direction="row"
                       alignItems="center"
                       justifyContent="center"
                       sx={{ borderBottom: 1, paddingX: 1, marginTop: -1, borderColor: 'divider' }}>
                    <TabList centered value={value} onChange={handleTabChange} aria-label="Tabs">
                        {details.cameras.map((camera, index) => (
                            <Tab key={index} value={`${camera.id}`} label={getTabName(camera)} />
                        ))}
                    </TabList>
                </Stack>
                {details.cameras.map((camera, index) => (
                    <TabPanel key={camera.type + index} value={`${camera.id}`}>
                        <Grid2 key={index} size={{ xs: 12, md: 6 }} justifyContent="center" alignItems="center">
                            <Stack alignItems="center" justifyContent="center" sx={{ padding: 2 }}>
                                <Camera cameraId={camera.id} birdhouseId={details.id} />
                            </Stack>
                        </Grid2>
                    </TabPanel>
                ))}
            </TabContext>
        </Box>
    </Box>
}